<template>
	<v-dialog v-model="dialog" persistent max-width="600">
		<v-card>
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">ファイルの削除履歴</v-toolbar-title>
			</v-toolbar>
			<v-card-text class="py-2">
				<v-data-table
					:headers="headers"
					:items="files"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="削除履歴はありません"
				>
					<template v-slot:item="{ item }">
						<tr>
							<td>{{ item.destory_date | dateFormatter }}</td>
							<td>{{ item.destroy_file_name }}</td>
							<td>{{ item.destroy_user.last_name + " " + item.destroy_user.first_name }}</td>
						</tr>
					</template>
				</v-data-table>
			</v-card-text>

			<v-card-actions>
				<v-row no-gutters>
					<v-col cols="4" />
					<v-col cols="4"> </v-col>
					<v-col cols="4">
						<v-row no-gutters justify="end">
							<v-btn color="grey darken-1" text @click="closeDialog"> 閉じる </v-btn>
						</v-row>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import rules from "../../../helper/rules"
import common from "../../../helper/common"
import moment from "moment/min/moment.min.js"
export default {
	props: {
		files: [],
	},
	filters: {
		dateFormatter(date) {
			return moment(date).format("YYYY/MM/DD")
		},
		timeFormatter(time) {
			return moment(time).format("HH:mm")
		},
	},
	data() {
		return {
			dialog: false,
			headers: [
				{ text: "削除日", value: "destroy_date", width: "100px" },
				{ text: "削除ファイル名", value: "destroy_file_name", width: "250px" },
				{ text: "削除者", value: "destroy_user_name", width: "150px" },
			],
		}
	},
	methods: {
		openDialog() {
			this.dialog = true
		},
		closeDialog() {
			this.dialog = false
		},
	},
	watch: {},
}
</script>
<style scoped></style>
